<script>
  import FormSubmitActions from '@/utils/actions/form_submit_actions'

  export default {
    name: 'SelectorMode',
    components: {
      CreateMode: () => import('./CreateMode.vue'),
      UseMode: () => import('./UseMode.vue'),
      CommonMode: () => import('./CommonMode.vue'),
    },
    props: {
      type: {
        type: String,
        required: true,
        default: 'spreadsheet',
      },
      integration: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      mode: 'create',
      items: [],
    }),
    computed: {
      currentComponent() {
        return this.mode === 'create' ? 'CreateMode' : 'UseMode'
      },
    },
    async mounted() {
      await this.listSheets()

      if (this.integration.itemId) {
        this.mode = 'use'
      }
    },
    methods: {
      async listSheets() {
        try {
          const formId = localStorage.getItem('formId')
          const response = await FormSubmitActions.listGoogleSheets(formId)
          this.items = response.data
        } catch (error) {
          console.error('Error listing sheets:', error)
        }
      },
      async createAndInitializeSpreadsheet(
        title,
        selectedFields,
        sendExisting,
        displayAnswer
      ) {
        try {
          const userId = localStorage.getItem('userId')
          const formId = localStorage.getItem('formId')
          const displayAnswers = displayAnswer === 'answer_values'
          await FormSubmitActions.createGoogleSheet(
            title,
            userId,
            formId,
            displayAnswers,
            sendExisting,
            selectedFields
          )

          console.log('Spreadsheet created and initialized.')
        } catch (err) {
          console.error('Error:', err)
        }
      },
      async updateSpreadsheet(
        spreadsheetId,
        selectedFields,
        sendExisting,
        displayAnswer
      ) {
        try {
          const userId = localStorage.getItem('userId')
          const formId = localStorage.getItem('formId')
          const displayAnswers = displayAnswer === 'answer_values'
          await FormSubmitActions.useGoogleSheet(
            spreadsheetId,
            userId,
            formId,
            displayAnswers,
            sendExisting,
            selectedFields
          )
        } catch (error) {
          console.error('Error updating spreadsheet:', error)
        }
      },
      async saveInfo({
        selectedFields,
        sendExisting,
        displayAnswer,
        name,
        selected,
      }) {
        console.log('SaveInfo', {
          mode: this.mode,
          selectedFields,
          sendExisting,
          displayAnswer,
          name,
          selected,
        })

        // Emit close event immediately to improve perceived performance
        this.$emit('close-integration')
        this.launchSnackbar()
        try {
          if (this.mode === 'create') {
            await this.createAndInitializeSpreadsheet(
              name,
              selectedFields,
              sendExisting,
              displayAnswer
            )
          } else {
            await this.updateSpreadsheet(
              selected,
              selectedFields,
              sendExisting,
              displayAnswer
            )
          }
        } catch (error) {
          console.error('Error saving configuration:', error)
          // You might want to show an error notification here
        }
      },
      launchSnackbar() {
        this.snackbarEventBus.$emit('snackbar', {
          emoji: this.constants.EMOJI.HANDS_UP,
          color: this.constants.SNACKBAR_CONSTANTS.COLORS.SECONDARY,
          text: 'Changes Successfully Saved',
        })
      },
    },
  }
</script>

<template>
  <div class="form-integrarion-container--wrapper">
    <h4 class="form-integrarion-text">Choose an option</h4>
    <v-radio-group
      v-model="mode"
      row
    >
      <v-radio
        :label="`Create a new ${type}`"
        value="create"
        class="mb-3"
      />
      <v-radio
        :label="`Use an existing ${type}`"
        value="use"
      />
    </v-radio-group>
    <component
      :is="currentComponent"
      :type="type"
      :integration="integration"
      :items="items"
      @save-info="saveInfo"
    />
  </div>
</template>

<style lang="scss">
  .form-integrarion-title {
    color: var(--v-grey_3-base);
    font-size: 12px;
    font-weight: 400;
  }

  .form-integrarion-text {
    color: var(--v-gray_700-base);
    font-size: 16px;
    font-weight: 500;
  }

  .form-integrarion-container--wrapper > h5 {
    margin-bottom: 20px;
  }
</style>
